import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function BlogAdminList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [submitter, setSubmitter] = useState(null);
  const [likes, setLikes] = useState(0);
  const [status, setStatus] = useState('accepted');
  const [emailMessage, setEmailMessage] = useState('');

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    const { data, error } = await supabase.from('blog_posts').select('*').order('created_at', { ascending: false });
    if (!error) setPosts(data);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this post?')) return;
    const { error } = await supabase.from('blog_posts').delete().eq('id', id);
    if (!error) {
      setMessage('Post deleted');
      fetchPosts();
    }
  };

  const handleOpenModal = async (post) => {
    // Fetch submitter info
    const { data: userData } = await supabase.from('users').select('full_name, email').eq('id', post.author_id).single();
    setSubmitter(userData);
    // Fetch likes
    const { count } = await supabase.from('blog_likes').select('*', { count: 'exact', head: true }).eq('post_id', post.id);
    setLikes(count || 0);
  };

  const handleCloseModal = () => {
    setSubmitter(null);
    setLikes(0);
    setStatus('accepted');
    setEmailMessage('');
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">Blog Posts</h2>
        <Link to="/admin/blog/new" className="btn btn-primary">New Post</Link>
      </div>
      {message && <div className="alert alert-info">{message}</div>}
      {loading ? <div>Loading...</div> : (
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {posts.map(post => (
              <tr key={post.id}>
                <td>{post.title}</td>
                <td>{post.status}</td>
                <td>{new Date(post.created_at).toLocaleString()}</td>
                <td>
                  <Link to={`/admin/blog/edit/${post.id}`} className="btn btn-sm btn-info me-2">Edit</Link>
                  <button className="btn btn-sm btn-danger me-2" onClick={() => handleDelete(post.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default BlogAdminList; 